"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFiles = exports.uploadFileContributions = exports.transformInitialValues = exports.stripSpecialChars = exports.stripHtml = exports.sanitizeHTML = exports.phq9Message = exports.isNotEmptyOrUndefined = exports.isEmpty = exports.getInterfaceOptions = exports.generateOptionsListFromArrayOrObjectArray = exports.generateDecendingOptionsListOfNumbers = exports.formatBytes = exports.flattenPayload = exports.fileUploadFields = exports.fieldList = exports.createFieldKey = exports.consolidateMutuallyExclusiveAnswers = exports.composeValidators = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.is-array.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.regexp.to-string.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _services = require("../services");
var _constants = require("../constants");
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var currentYear = new Date().getFullYear();
var camelToDash = function camelToDash(str) {
  var subst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  return str.replace(/\W_.+/g, subst).replace(/([a-z\d])([A-Z])/g, "$1".concat(subst, "$2"));
};
var composeValidators = exports.composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function (value) {
    for (var _i = 0, _validators = validators; _i < _validators.length; _i++) {
      var validator = _validators[_i];
      var error = validator(value);
      if (error) {
        return error;
      }
    }
    return undefined;
  };
};
var stripSpecialChars = exports.stripSpecialChars = function stripSpecialChars() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var subst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  return camelToDash(str.replace(_constants.safe_name_regex, subst), subst).toLowerCase();
};
var generateDecendingOptionsListOfNumbers = exports.generateDecendingOptionsListOfNumbers = function generateDecendingOptionsListOfNumbers() {
  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : currentYear;
  var target = new Array(max);
  return _lodash["default"].reduce(target, function (acc, unknown, num) {
    var year = start - num;
    return [].concat((0, _toConsumableArray2["default"])(acc), [{
      label: year,
      value: year
    }]);
  }, []);
};
var generateOptionsListFromArrayOrObjectArray = exports.generateOptionsListFromArrayOrObjectArray = function generateOptionsListFromArrayOrObjectArray(options) {
  return options && _lodash["default"].has(options[0], "label") ? _lodash["default"].reduce(options, function (acc, _ref) {
    var label = _ref.label,
      answer = _ref.answer,
      value = _ref.value,
      id = _ref.id;
    var v = answer;
    if (!_lodash["default"].isNumber(v) && value) {
      if (!v) {
        v = value;
      }
    }
    return [].concat((0, _toConsumableArray2["default"])(acc), [{
      label: label,
      value: v,
      id: id
    }]);
  }, []) : _lodash["default"].reduce(options, function (acc, option) {
    return [].concat((0, _toConsumableArray2["default"])(acc), [{
      label: option,
      value: option
    }]);
  }, []);
};
var formatBytes = exports.formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return '0 Bytes';
  var k = 1024,
    dm = decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
var isEmpty = exports.isEmpty = function isEmpty(value) {
  return value === '' || value === undefined || value === null;
};
var isNotEmptyOrUndefined = exports.isNotEmptyOrUndefined = function isNotEmptyOrUndefined() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return !!string && !_lodash["default"].isEmpty("".concat(string).trim());
};
var fieldList = exports.fieldList = function fieldList(schema) {
  var flatSchema = _lodash["default"].flatten(schema);
  return _lodash["default"].flatten(flatSchema.map(function (form) {
    return form.input;
  }));
};
var phq9Message = exports.phq9Message = function phq9Message(data, schema) {
  //currently expect only one phq9 component per form.  If this ever changes,
  //this function should be updated
  var phq9 = _lodash["default"].find(fieldList(schema), {
    "interface": 'phq9'
  });
  return !_lodash["default"].isUndefined(phq9) ? data["".concat(phq9.name, "_9")] > 0 : false;
};

//flatten an object in data payload by one layer
var flattenPayload = exports.flattenPayload = function flattenPayload(data, schema) {
  var flattenFields = ['gad7', 'phq9', 'ess', 'acq5', 'simple_matrix', 'typing_test', 'height_intl', 'weight_intl'];
  var fields = _lodash["default"].map(_lodash["default"].filter(fieldList(schema), function (field) {
    return _lodash["default"].includes(flattenFields, field["interface"]);
  }), 'name');
  var flatData = _lodash["default"].reduce(fields, function (result, field) {
    return _objectSpread(_objectSpread({}, result), data[field]);
  }, {});
  return _objectSpread(_objectSpread({}, _lodash["default"].omit(data, fields)), flatData);
};
var fileUploadFields = exports.fileUploadFields = function fileUploadFields(schema) {
  return fieldList(schema).filter(function (field) {
    return field["interface"] === 'file_uploader';
  });
};
var uploadFiles = exports.uploadFiles = function uploadFiles() {
  var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
    participant_auth_token = _ref2.participant_auth_token,
    auth_token = _ref2.auth_token,
    enrollment_identifier = _ref2.enrollment_identifier,
    node_slug = _ref2.node_slug,
    bucket = _ref2.bucket;
  return Promise.all(files.map(function (file) {
    try {
      return (0, _services.uploadSecure)({
        participant_auth_token: participant_auth_token,
        auth_token: auth_token,
        enrollment_identifier: enrollment_identifier,
        node_slug: node_slug,
        bucket: bucket
      }, file);
    } catch (err) {
      throw new Error('uploadSecure');
    }
  }));
};
var uploadFileContributions = exports.uploadFileContributions = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data, schema) {
    var participant,
      fileUploadFields,
      uploads,
      fileUploadFieldNames,
      dataWithUploadInteractions,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          participant = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          fileUploadFields = fieldList(schema).filter(function (field) {
            return field["interface"] === 'file_uploader';
          });
          _context.next = 4;
          return Promise.all(fileUploadFields.map(function (_ref4) {
            var name = _ref4.name,
              bucket = _ref4.bucket;
            return uploadFiles(data[name], _objectSpread(_objectSpread({}, participant), {}, {
              bucket: bucket
            }));
          }));
        case 4:
          uploads = _context.sent;
          fileUploadFieldNames = fileUploadFields.map(function (field) {
            return field.name;
          });
          if (!(uploads.length !== fileUploadFieldNames.length)) {
            _context.next = 8;
            break;
          }
          throw new Error("interaction lists mismatches file upload field count");
        case 8:
          dataWithUploadInteractions = _lodash["default"].reduce(data, function (acc, val, name) {
            if (_lodash["default"].includes(fileUploadFieldNames, name)) {
              acc[name] = uploads[_lodash["default"].indexOf(fileUploadFieldNames, name)];
            } else {
              acc[name] = val;
            }
            return acc;
          }, {});
          return _context.abrupt("return", dataWithUploadInteractions);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function uploadFileContributions(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var createFieldKey = exports.createFieldKey = function createFieldKey(_ref5) {
  var group = _ref5.group,
    field = _ref5.field,
    component = _ref5.component;
  var key = _lodash["default"].has(group, "name") ? "".concat(stripSpecialChars(group.name), ".") : "";
  // creating a field key based on fieldset NAME (if we have one)
  // if we do not, just use the field label

  if (_lodash["default"].has(field, 'name') && !_lodash["default"].isEmpty(field.name)) {
    key += stripSpecialChars(field.name);
  } else {
    key += stripSpecialChars(field.label);
    // depcrecation warning, this will be removed
    if (!_lodash["default"].includes(_constants.allowedNoName, component)) console.warn("Your ".concat(component, " does not contain a \"name\" field. Please make sure you always supply a \"name\" value."));
  }
  return key;
};
var getInterfaceOptions = exports.getInterfaceOptions = function getInterfaceOptions(_ref6) {
  var intf = _ref6["interface"],
    options = _ref6.options;
  switch (intf) {
    case 'range_1to10':
      return _constants.range_1to10;
    case 'range_0to10':
      return _constants.range_0to10;
    case 'range_0to5':
      return _constants.range_0to5;
    default:
      return options;
  }
};
var sanitizeHTML = exports.sanitizeHTML = function sanitizeHTML(dirtyHtmlString) {
  return dirtyHtmlString ? (0, _sanitizeHtml["default"])(dirtyHtmlString) : '';
};
var consolidateMutuallyExclusiveAnswers = exports.consolidateMutuallyExclusiveAnswers = function consolidateMutuallyExclusiveAnswers(data) {
  var working = _objectSpread({}, data);
  Object.keys(working).forEach(function (key) {
    if ((working === null || working === void 0 ? void 0 : working["".concat(key, "_exclusive")]) !== undefined) {
      if ((working === null || working === void 0 ? void 0 : working["".concat(key, "_exclusive")]) !== '') {
        if (Array.isArray(working[key])) {
          working[key] = [Number(working["".concat(key, "_exclusive")])];
        } else {
          working[key] = Number(working["".concat(key, "_exclusive")]);
        }
      }
      delete working["".concat(key, "_exclusive")];
    }
  });
  return working;
};
var transformInitialValues = exports.transformInitialValues = function transformInitialValues(_ref7) {
  var initialValues = _ref7.initialValues,
    schema = _ref7.schema;
  var working = initialValues ? _objectSpread({}, initialValues) : undefined;
  if (working) {
    Object.keys(working).forEach(function (key) {
      var _schema$, _schema$$input;
      var formField = schema === null || schema === void 0 ? void 0 : (_schema$ = schema[0]) === null || _schema$ === void 0 ? void 0 : (_schema$$input = _schema$.input) === null || _schema$$input === void 0 ? void 0 : _schema$$input.find(function (v) {
        return (v === null || v === void 0 ? void 0 : v.name) === key;
      });
      if (formField) {
        var _formField$mutually_e, _working$key;
        var mutuallyExclusiveValues = formField === null || formField === void 0 ? void 0 : (_formField$mutually_e = formField.mutually_exclusive_answers) === null || _formField$mutually_e === void 0 ? void 0 : _formField$mutually_e.map(function (v) {
          return Number(v.answer);
        });
        if (mutuallyExclusiveValues !== null && mutuallyExclusiveValues !== void 0 && mutuallyExclusiveValues.includes(Array.isArray(working[key]) ? (_working$key = working[key]) === null || _working$key === void 0 ? void 0 : _working$key[0] : working[key])) {
          if (Array.isArray(working[key])) {
            var _working$key2;
            working["".concat(key, "_exclusive")] = (_working$key2 = working[key]) === null || _working$key2 === void 0 ? void 0 : _working$key2[0].toString();
          } else {
            working["".concat(key, "_exclusive")] = working[key].toString();
          }
          working[key] = undefined;
        }
      }
    });
  }
  return working;
};
var stripHtml = exports.stripHtml = function stripHtml() {
  var _doc$body$textContent;
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var sanitizedInput = (string === null || string === void 0 ? void 0 : string.replace(/<+/g, '<').replace(/>+/g, '>')) || '';
  var parser = new DOMParser();
  var doc = parser.parseFromString(sanitizedInput, 'text/html');
  return ((_doc$body$textContent = doc.body.textContent) === null || _doc$body$textContent === void 0 ? void 0 : _doc$body$textContent.replace(/\u00A0/g, ' ').trim()) || '';
};